export const setHeaderFooterSize = payload => ({
  payload: {
    unit: '%',
    value: payload.size
  }
});
